import translations from '@/locales/fr.json';
import i18n, { TranlationStructure } from '@/plugins/i18n';

export class StringUtils {
    public truncateString(str: string, end: number): string {
        return str.length <= end ? str : str.slice(0, end) + '...';
    }

    public parseHashRoutePartToObject(fullHash: string): any {
        const hash = fullHash.substring(1);

        return hash.split('&').reduce(function(result: any, item: string) {
            const parts: string[] = item.split('=');
            result[parts[0]] = parts[1];
            return result;
        }, {});
    }

    public getPeriodiciteAsString(periodicite: number): string {

        if (Number(periodicite) === 0) {
            return '';
        }
        else if (periodicite % 365 === 0) {
            return i18n.global.t('preventive.periodicite.annee', { count: periodicite / 365 });
        } else if (periodicite % 30 === 0) {
            return i18n.global.t('preventive.periodicite.mois', { count: periodicite / 30 });
        } else if (periodicite % 7 === 0) {
            return i18n.global.t('preventive.periodicite.semaine', { count: periodicite / 7 });
        } else if (periodicite != 0) {
            return i18n.global.t('preventive.periodicite.jours', { count: periodicite });
        } else {
            return '';
        }
    }

    public getKeyFromFRTranslation(libelle: string): string {
        try {
            const traduction = translations.find((t: any) => t.libelle === libelle);

            if (!traduction) {
                return '';
            }

            return traduction.nom;
        } catch (e) {
            return '';
        }
    }

    /**
     * Traduit une clé i18n si une traduction existe dans la langue courante,
     * sinon renvoie le libellé par défaut
     */
    public traduireOuDefaut(cle: string | null | undefined, defaut: string): string {
        return cle && i18n.global.te(cle) ? (i18n.global.t(cle) as string) : defaut;
    }

    public buildi18nMessages(flatMessages: { nom: string; libelle: string }[]): TranlationStructure {
        const result: TranlationStructure = {};

        flatMessages.forEach(({ nom, libelle }) => {
            const keys = nom.split('.');
            let current = result;

            keys.forEach((key, index) => {
                if (index === keys.length - 1) {
                    current[key] = libelle;
                } else {
                    if (typeof current[key] === 'string') {
                        current[key] = {
                            value: current[key],
                        };
                    }
                    current[key] = current[key] || {};
                    current = current[key] as TranlationStructure;
                }
            });
        });

        return result;
    }

}

export default new StringUtils();
